import { Stack } from "@mui/material";
import { Component } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { VacancyTable } from "../../components/table/VacancyTable";
import { SettingsJobList } from "../../data/settings/SettingsJobList";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface SelectVacancyDialogProps extends WithLocaleProps {
  theme?: any;
  organization?: any;
  user?: any;
  error?: string;
  vacancies?: any[];
  position?: any;
  onCancel?: () => void;
  onSave?: (e: any, vacancy: any) => void;
}

class SelectVacancyDialogBase extends Component<SelectVacancyDialogProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      position: null,
      vacancy: null
    };
  }

  componentDidMount() {
    //const { onLoadManagers } = this.props;
    //if (onLoadManagers) onLoadManagers();
  }

  onSave(e: any) {
    const { onSave } = this.props;
    const { vacancy } = this.state;
    if (onSave) onSave(e, vacancy);
  }

  onVacancySelect(e: any, vacancy: any) {
    this.setState({ vacancy });
  }

  render() {
    const { organization, theme, user, onCancel, error, vacancies, position, translate } =
      this.props;
    const { vacancy } = this.state;

    const newPosition = SettingsJobList.createVacancy();
    newPosition.fullName = translate("dialogs.createNewPosition");
    newPosition.isCreatable = true;

    return (
      <Dialog
        theme={theme}
        open={true}
        onClose={onCancel}
        fullWidth={true}
        maxWidth='sm'
        maxHeight='300px'
        title={translate("dialogs.selectJob")}
        actions={[
          {
            label: translate("common.select"),
            variant: "filled",
            primary: true,
            disabled: vacancy === null,
            onClick: this.onSave.bind(this)
          },
          {
            label: translate("common.cancel"),
            onClick: onCancel
          }
        ]}
      >
        <Stack spacing={4}>
          <div>{translate("dialogs.selectVacancy", { name: position?.name })}</div>
          <VacancyTable
            theme={theme}
            paper={false}
            pagination={false}
            showFooter={false}
            dense={true}
            rows={vacancies ? [...vacancies, newPosition] : null}
            selected={vacancy}
            onVacancySelect={this.onVacancySelect.bind(this)}
            noRowsMessage={this.props.translate("common.noVacancies")}
          />
        </Stack>
      </Dialog>
    );
  }
}

export const SelectVacancyDialog = withLocale(SelectVacancyDialogBase);
